import React from 'react'
import {Link, NavLink} from 'react-router-dom'
import {navbarNavClick, objectLang} from "../functions"

export class NavbarClass extends React.Component {

    render() {

        const {auth, avatarLink, currentLang, setResponseSearch, changeSelect} = this.props

        let setValueLang
        if (currentLang) {
            setValueLang = currentLang.lang
        } else {
            setValueLang = 'en'
        }
        const lng = objectLang().languages

        const languages = []
        for (const i in lng) {
            languages.push([i, lng[i].navbar.optionalsLanguage])
        }

        return (
            <>
                <div id={'nav'} className={"sticky-top bg-body-tertiary navbar-expand-md border border-1 shadow"}>

                    <nav className={"navbar p-0"} id={"navbar"}>
                        <div className={"container-fluid flex-xl-nowrap col col-12"}>

                            <div className={'d-flex flex-nowrap col col-xl-2 col-sm-2 col-md-4'}>
                                {/*Авторизованный аватар*/}
                                {auth.isAuthenticated &&
                                <div>
                                    <div
                                        style={{backgroundImage: `url(${avatarLink})`}}
                                        className={"avatar-auth border rounded-circle m-1"}/>
                                </div>}

                                {/*Неавторизованный аватар*/}
                                {!auth.isAuthenticated &&
                                <div>
                                    <div className={"avatar-not-auth border rounded-circle m-1 mb-xl-0"}/>
                                </div>}

                                {/*Никнейм*/}
                                <NavLink to={`/${setValueLang}/`}
                                         className={"d-flex justify-content-start align-items-center nav-name text-decoration-none text-success inactive ps-2"}>
                                    <div className={"overflow-hidden text-center d-flex"}>

                                        {/*Авторизованный Никнейм*/}
                                        {auth.isAuthenticated &&
                                        <h5 id={"navUserName"}
                                            className={"d-flex justify-content-center align-items-center"}>
                                            {currentLang.navbar.isAuth.title} {auth.nickName}</h5>}

                                        {/*Неавторизованный Никнейм*/}
                                        {!auth.isAuthenticated &&
                                        <h5 id={"navTitle"} className={"d-flex justify-content-center"}>
                                            {currentLang.navbar.isNotAuth.title}
                                        </h5>}
                                    </div>
                                </NavLink>
                            </div>

                            {auth.isAuthenticated && !auth.superUser && <div className={'d-none'}>
                                <div className={"overflow-hidden text-center mb-1 pe-2"}>
                                    {/*Кнопка поиска*/}
                                    <button id={"navBtnSearch"}
                                            className={"btn btn-outline-primary border-0 fw-bold fs-5"}
                                            type={"button"}
                                            onClick={() => {
                                                setResponseSearch(true)
                                            }}>
                                        {currentLang.navbar.isAuth.btnSearch}
                                    </button>
                                </div>
                            </div>}

                            {/*Кнопка развертывания меню в мобильнике*/}
                            <button className={"navbar-toggler"}
                                    type={"button"}
                                    onClick={navbarNavClick}
                                    data-bs-toggle={"collapse"}
                                    data-bs-target={"navbar-nav"}
                                    aria-controls={"navbar-nav"}
                                    aria-expanded={"false"}
                                    aria-label={"Toggle navigation"}>
                                <span className={"navbar-toggler-icon"}/>
                            </button>

                            {/*Мобильное меню*/}
                            <div className={"container collapse navbar-collapse mt-2 mb-2 justify-content-center"}
                                 id={"navbar-nav"}>

                                {/*Само меню*/}
                                <ul className={"navbar-nav ms-1 me-auto mb-lg-0"}>

                                    {/*Селектор языков*/}
                                    {<li id={"navSelLang"} className={"nav-item ps-2"}>
                                        <select
                                            className={"form-select w-auto"}
                                            name={"language"}
                                            id={"language"}
                                            onChange={changeSelect}
                                            defaultValue={setValueLang}
                                        >{languages.map((lang, index) => {
                                                return (
                                                    <option
                                                        value={lang[0]}
                                                        key={index}
                                                    >{lang[1][lang[0]]}
                                                    </option>
                                                )
                                            }
                                        )}
                                        </select>
                                    </li>}

                                    {/*Главная страница*/}
                                    {<li id={"navToHome"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.linkToHome}`}
                                            className={"nav-link inactive rounded-3"}
                                            onClick={navbarNavClick}>
                                            {currentLang.navbar.toHome}
                                        </NavLink>
                                    </li>}

                                    {/*Страница "Интернет-телефон"*/}
                                    {auth.isAuthenticated && false && <li id={"navBtnNetphone"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.isAuth.linkNetphone}`}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}>
                                            {currentLang.navbar.isAuth.btnNetphone}
                                        </NavLink>
                                    </li>}

                                    {/*Страница "Google Диск"*/}
                                    {auth.isAuthenticated && auth.authenticatedVia === 'google' && <li id={"navBtnGoogleDrive"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.isAuth.linkGoogleDrive}`}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}>
                                            {currentLang.navbar.isAuth.btnGoogleDrive}
                                        </NavLink>
                                    </li>}

                                    {/*Страница "Google Mail"*/}
                                    {auth.isAuthenticated && auth.authenticatedVia === 'google' && <li id={"navBtnGoogleMail"} className={"nav-item ps-2"}>
                                        <NavLink
                                            target={'_blank'}
                                            to={currentLang.navbar.isAuth.linkGoogleMail}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}>
                                            {currentLang.navbar.isAuth.btnGoogleMail}
                                        </NavLink>
                                    </li>}

                                    {/*Страница авторизации*/}
                                    {!auth.isAuthenticated && <li id={"navBtnAuth"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.isNotAuth.linkAuth}`}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}>
                                            {currentLang.navbar.isNotAuth.btnAuth}
                                        </NavLink>
                                    </li>}

                                    {/*Страница регистрации*/}
                                    {!auth.isAuthenticated && <li id={"navBtnRegister"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.isNotAuth.linkRegister}`}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}>
                                            {currentLang.navbar.isNotAuth.btnRegister}
                                        </NavLink>
                                    </li>}

                                    {/*Страница "Мои линки"*/}
                                    {auth.isAuthenticated && <li id={"navBtnMyLinks"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}/folder/open/${auth.rootFolder}`}
                                            className={"nav-link inactive rounded-3"}
                                            aria-current={"page"}
                                            onClick={navbarNavClick}>
                                            {currentLang.navbar.isAuth.btnMyLinks}
                                        </NavLink>
                                    </li>}

                                    {/*Страница "Средства"*/}
                                    {auth.isAuthenticated && <li id={"navBtnMoney"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}/money/main`}
                                            className={"nav-link inactive rounded-3"}
                                            onClick={navbarNavClick}
                                            aria-current={"page"}>
                                            {currentLang.navbar.isAuth.btnMoney}
                                        </NavLink>
                                    </li>}

                                    {/*Страница Публичные линки*/}
                                    {currentLang.lang === 'ru' && <li id={"navBtnPublic"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.isNotAuth.linkPublicLinks}`}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}
                                            aria-current={"page"}>
                                            {currentLang.navbar.isNotAuth.btnPublicLinks}
                                        </NavLink>
                                    </li>}

                                    {/*Страница "Профиль"*/}
                                    {auth.isAuthenticated && <li id={"navBtnProfile"} className={"nav-item ps-2"}>
                                        <NavLink
                                            to={`/${setValueLang}${currentLang.navbar.isAuth.linkProfile}`}
                                            onClick={navbarNavClick}
                                            className={"nav-link inactive rounded-3"}>
                                            {currentLang.navbar.isAuth.btnProfile}
                                        </NavLink>
                                    </li>}

                                    {/*Выход из профиля"*/}
                                    {auth.isAuthenticated && <li id={"navBtnOut"} className={"nav-item ps-2"}>
                                        <Link to={`/${setValueLang}/exit`}
                                              className={"nav-link inactive rounded-3 text-danger"}>
                                            {currentLang.navbar.isAuth.btnOut}
                                        </Link>
                                    </li>}

                                </ul>

                            </div>

                        </div>
                    </nav>
                </div>
            </>
        )
    }
}
